import { Fragment } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'core/libs/recompose';

import withTheme from 'core/hocs/withTheme';
import withBreakpoint from 'core/hocs/withBreakpoint';

import themePropTypes from 'core/utils/prop-types/theme';


const NativeStyles = ({ isDesktop, theme, blockId }) => {
  const {
    sponsored,
  } = theme.ads;

  return (
    <Fragment>
      <style jsx global>{`
        #begun_block_${blockId}
          .sponsorship
            &__link
              display block

            &__text
            &__image
              display inline-block
              vertical-align middle
              margin 0

            &__image
              margin-left 6px
      `}</style>
      <style jsx global>{`
        #begun_block_${blockId}
          .sponsorship
            &__text
              font ${sponsored.font}
              color ${sponsored.color}

            &__image
              max-height ${isDesktop ? 40 : 30}px
              max-width ${isDesktop ? 120 : 90}px
      `}</style>
    </Fragment>
  );
};

NativeStyles.propTypes = {
  blockId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  isDesktop: PropTypes.bool,
  theme: themePropTypes(`
    {
      ads: {
        sponsored: {
          font,
          color,
        }
      }
    }
  `),
};

export default function sponsoredStyles(Component) {
  return compose(
    withTheme,
    withBreakpoint,
  )(props => (
    <Fragment>
      <NativeStyles {...props} />
      <Component {...props} />
    </Fragment>
  ));
}
